module.exports = __webpack_public_path__ + "img/welding-3.2fd279f7.jpg";